/**
 * PDP Recommended for you — expand sparse same-shape pools (Liquid < 6 peers)
 * using one shape-filtered collection fetch (Shop All sibling groups).
 *
 * Anti-flicker:
 * - Non-sparse grids: Liquid paints immediately (data-ciw-rec-ready already set).
 * - Sparse grids: tracks stay hidden until the expand finishes (or times out),
 *   then paint once — never Liquid 1-up → swap to 10.
 * - Zero Liquid peers (rare compound shapes): empty shell mounts, then siblings fill once.
 */
(function () {
  var TARGET = 10;
  var READY_TIMEOUT_MS = 4500;
  var CACHE_PREFIX = 'ciwPdpRecShape:v2:';

  /* Same groups as snippets/ciw-gusa-active-pills.liquid (shape pills). */
  var SHAPE_GROUPS = [
    ['Aviator', 'Pilot', 'Navigator'],
    ['Browline', 'Rectangle/ Browline'],
    ['Cat Eye', 'Semi Cat Eye', 'Semi-Cat Eye', 'Round, Semi-Cat Eye'],
    ['Oval', 'Semi-Oval', 'Rounded Edges'],
    ['Rectangle', 'Rectangular', 'Rectangular-Square', 'Rectangular/ Squared', 'Square, Rectangular/ Squared'],
    ['Round'],
    ['Square'],
    ['Wayframe', 'Wayfarer'],
    ['Wrap', 'Shield'],
    ['Geometric', 'Geomteric-Square', 'Phantos', 'Phantos/ Pantos', 'Pillow', 'Butterfly', 'Oversized'],
  ];

  function qs(root, sel) {
    return (root || document).querySelector(sel);
  }

  function qsa(root, sel) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function markReady() {
    qsa(document, '[data-ciw-rec-enhance]').forEach(function (el) {
      el.setAttribute('data-ciw-rec-ready', '1');
    });
  }

  function hideRecHosts() {
    qsa(document, '[data-ciw-rec-enhance]').forEach(function (el) {
      el.style.display = 'none';
      el.setAttribute('data-ciw-rec-ready', '1');
    });
  }

  function normalize(s) {
    return String(s || '')
      .trim()
      .toLowerCase();
  }

  function resolveShapeGroup(shape) {
    var shapeN = normalize(shape);
    if (!shapeN) return { fetchShape: '', peers: [] };
    for (var i = 0; i < SHAPE_GROUPS.length; i++) {
      var group = SHAPE_GROUPS[i];
      for (var j = 0; j < group.length; j++) {
        if (normalize(group[j]) === shapeN) {
          return { fetchShape: group[0], peers: group.slice() };
        }
      }
    }
    return { fetchShape: shape, peers: [shape] };
  }

  function peerSetFromBoot(boot) {
    if (boot.shapePeers) {
      return String(boot.shapePeers)
        .split('|')
        .map(function (s) {
          return normalize(s);
        })
        .filter(Boolean);
    }
    return resolveShapeGroup(boot.shape).peers.map(normalize);
  }

  function fetchShapeFromBoot(boot) {
    if (boot.fetchShape) return boot.fetchShape;
    return resolveShapeGroup(boot.shape).fetchShape || boot.shape;
  }

  function cardHandle(node) {
    return String(node.getAttribute('data-handle') || '').trim();
  }

  function cardBrand(node) {
    return String(node.getAttribute('data-brand-sort') || node.getAttribute('data-vendor') || '')
      .trim()
      .toLowerCase();
  }

  function cardShape(node) {
    return String(node.getAttribute('data-ciw-frame-shape') || '').trim().toLowerCase();
  }

  function parseCards(html) {
    if (!html) return [];
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var cards = qsa(doc, '#product-grid .ciw-card');
    if (!cards.length) cards = qsa(doc, '.ciw-card');
    return cards;
  }

  function cacheKey(boot) {
    return (
      CACHE_PREFIX +
      normalize(boot.collectionHandle) +
      ':' +
      normalize(fetchShapeFromBoot(boot))
    );
  }

  function readCache(boot) {
    try {
      var raw = sessionStorage.getItem(cacheKey(boot));
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.html || Date.now() - (parsed.at || 0) > 30 * 60 * 1000) return null;
      return parsed.html;
    } catch (e) {
      return null;
    }
  }

  function writeCache(boot, html) {
    try {
      sessionStorage.setItem(
        cacheKey(boot),
        JSON.stringify({
          at: Date.now(),
          html: html,
        })
      );
    } catch (e) {
      /* ignore quota */
    }
  }

  function filterAndRank(nodes, boot) {
    var peers = peerSetFromBoot(boot);
    var brandN = normalize(boot.brand);
    var excludeN = normalize(boot.exclude);
    var filtered = nodes.filter(function (node) {
      var handle = normalize(cardHandle(node));
      if (!handle || (excludeN && handle === excludeN)) return false;
      if (peers.length) {
        var nodeShape = cardShape(node);
        if (nodeShape && peers.indexOf(nodeShape) === -1) return false;
      }
      return true;
    });
    if (!brandN) return filtered;
    return filtered.slice().sort(function (a, b) {
      var aMatch = cardBrand(a) === brandN ? 0 : 1;
      var bMatch = cardBrand(b) === brandN ? 0 : 1;
      return aMatch - bMatch;
    });
  }

  function toMobileCard(ciwCard) {
    var handle = cardHandle(ciwCard);
    var brand = ciwCard.getAttribute('data-brand-sort') || '';
    var shape = ciwCard.getAttribute('data-ciw-frame-shape') || '';
    var link = qs(ciwCard, 'a');
    var href = link && link.getAttribute ? link.getAttribute('href') : '/products/' + handle;
    var titleEl = qs(ciwCard, '.ciw-card__title, .ciw-best-seller-display-title, [data-ciw-card-title]');
    var title = titleEl ? titleEl.textContent.trim() : handle;
    var img = qs(ciwCard, 'img');
    var price = qs(ciwCard, '.ciw-card__price, .price');
    var article = document.createElement('article');
    article.className = 'ciw-pdp-rec__card';
    article.setAttribute('data-handle', handle);
    article.setAttribute('data-brand-sort', brand);
    article.setAttribute('data-ciw-frame-shape', shape);
    article.innerHTML =
      '<a href="' +
      href +
      '" class="ciw-pdp-rec__media" aria-label="' +
      title.replace(/"/g, '&quot;') +
      '">' +
      (img
        ? '<img class="ciw-pdp-rec__img ciw-pdp-rec__img--front" src="' +
          (img.currentSrc || img.src) +
          '" alt="" loading="lazy" width="400" height="200">'
        : '') +
      '</a>' +
      '<a href="' +
      href +
      '" class="ciw-pdp-rec__info">' +
      '<span class="ciw-pdp-rec__title">' +
      title +
      '</span>' +
      (price ? '<span class="ciw-pdp-rec__price">' + price.innerHTML + '</span>' : '') +
      '</a>';
    return article;
  }

  function applyTracks(nodes) {
    var desktopTrack = qs(document, '[data-pdp-rec-track]');
    var mobileTrack = qs(document, '[data-ciw-pdp-rec-track]');
    var picked = (nodes || []).slice(0, TARGET);
    if (!picked.length) {
      hideRecHosts();
      return;
    }
    if (desktopTrack) {
      var frag = document.createDocumentFragment();
      picked.forEach(function (node) {
        frag.appendChild(node.cloneNode(true));
      });
      desktopTrack.innerHTML = '';
      desktopTrack.appendChild(frag);
    }
    if (mobileTrack) {
      var fragM = document.createDocumentFragment();
      picked.forEach(function (node) {
        fragM.appendChild(toMobileCard(node));
      });
      mobileTrack.innerHTML = '';
      mobileTrack.appendChild(fragM);
    }
    markReady();
    document.dispatchEvent(new CustomEvent('ciw:pdp-rec-enhanced'));
  }

  function ensureShapeFetch(boot) {
    if (window.__CIW_PDP_REC_SHAPE_FETCH) return window.__CIW_PDP_REC_SHAPE_FETCH;
    var cached = readCache(boot);
    if (cached) {
      window.__CIW_PDP_REC_SHAPE_FETCH = Promise.resolve(cached);
      return window.__CIW_PDP_REC_SHAPE_FETCH;
    }
    var fetchShape = fetchShapeFromBoot(boot);
    var params = new URLSearchParams();
    params.set('filter.v.m.custom.shape', fetchShape);
    params.set('filter.v.availability', '1');
    if (boot.previewThemeId) params.set('preview_theme_id', boot.previewThemeId);
    var url =
      '/collections/' + encodeURIComponent(boot.collectionHandle || 'eyeglasses') + '?' + params.toString();
    window.__CIW_PDP_REC_SHAPE_FETCH = fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (res.status === 429) {
          return new Promise(function (resolve) {
            setTimeout(function () {
              fetch(url, { credentials: 'same-origin' })
                .then(function (r2) {
                  return r2.ok ? r2.text() : '';
                })
                .then(resolve)
                .catch(function () {
                  resolve('');
                });
            }, 700);
          });
        }
        return res.ok ? res.text() : '';
      })
      .then(function (html) {
        if (html) writeCache(boot, html);
        return html || '';
      })
      .catch(function () {
        return '';
      });
    return window.__CIW_PDP_REC_SHAPE_FETCH;
  }

  function expandSparse(boot) {
    if (window.__ciwPdpRecEnhanceStarted) return;
    window.__ciwPdpRecEnhanceStarted = true;

    var timedOut = false;
    var timeoutId = window.setTimeout(function () {
      timedOut = true;
      var count =
        document.querySelectorAll('[data-pdp-rec-track] .ciw-card').length +
        document.querySelectorAll('[data-ciw-pdp-rec-track] .ciw-pdp-rec__card').length;
      if (count < 1) hideRecHosts();
      else markReady();
    }, READY_TIMEOUT_MS);

    ensureShapeFetch(boot).then(function (html) {
      if (timedOut) return;
      window.clearTimeout(timeoutId);
      var ranked = filterAndRank(parseCards(html), boot);
      if (ranked.length >= 1) applyTracks(ranked);
      else {
        var existing =
          document.querySelectorAll('[data-pdp-rec-track] .ciw-card').length +
          document.querySelectorAll('[data-ciw-pdp-rec-track] .ciw-pdp-rec__card').length;
        if (existing < 1) hideRecHosts();
        else markReady();
      }
    });
  }

  function init() {
    var sparseHost = qs(document, '[data-ciw-rec-enhance][data-ciw-rec-sparse="1"]');
    if (!sparseHost) {
      markReady();
      return;
    }
    var boot = window.__CIW_PDP_REC_BOOT || {
      shape: sparseHost.getAttribute('data-ciw-rec-shape') || '',
      fetchShape: sparseHost.getAttribute('data-ciw-rec-fetch-shape') || '',
      shapePeers: sparseHost.getAttribute('data-ciw-rec-shape-peers') || '',
      brand: sparseHost.getAttribute('data-ciw-rec-brand') || '',
      frameType: sparseHost.getAttribute('data-ciw-rec-frame-type') || '',
      exclude: sparseHost.getAttribute('data-ciw-rec-exclude') || '',
      collectionHandle: sparseHost.getAttribute('data-ciw-rec-collection') || 'eyeglasses',
      previewThemeId: sparseHost.getAttribute('data-ciw-rec-preview-theme') || '',
      sparse: true,
    };
    if (!boot.shape) {
      markReady();
      return;
    }
    expandSparse(boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
